import ApplicationRecord from "./ApplicationRecord";

import Link from "./Link";
import ImageRecord from "./ImageRecord";
import Communication from "./Communication";
import OpeningHours from "./OpeningHours";
import Contact from "./Contact";
/**
 * Home page.
 *
 *
 */
export default class HomePage extends ApplicationRecord({
  /**
   * @type {Number}
   */
  ID: -1,
  /**
   * Absolute path
   * @type {String}
   */
  URL: "",
  /**
   * Relative path
   * @type {String}
   */
  Path: "",
  /**
   * @type {String}
   */
  Title: "",
  /**
   * @type {Boolean}
   */
  ShowInMenus: false,
  /**
   * @type {String}
   */
  SlideshowCaption: "",
  /**
   * @type {String}
   */
  SlideshowCaptionTips: "",
  /**
   * @type {Object}
   */
  _embedded: {},
}) {
  /**
   * Get the communication section for the page.
   * @return {String}
   */
  communication() {
    return this._getOne("Communication", Communication).Content;
  }

  /**
   * @return {List<Link>} the links the page have
   */
  links() {
    return this._getMany("Links", (l) => new Link(l));
  }

  /**
   * @return {List<ImageRecord>} Images to display in the slideshow, ordered.
   */
  slideshowImages() {
    return this._getMany("ImagesForSlideshow", (i) => new ImageRecord(i));
  }

  /**
   * @return {List<ImageRecord>} Images to display in the slideshow, for mobile.
   */
  slideshowMobileImages() {
    return this._getMany("MobileImagesForSlideshow", (i) => new ImageRecord(i));
  }

  /**
   * @return {List<OpeningHours>}
   */
  timetable() {
    return this._getMany("TimeTable", (t) => new OpeningHours(t));
  }
  /**
   * @return {List<Contact>}
   */
  contacts() {
    return this._getMany("Contacts", (c) => new Contact(c));
  }
  /**
   * @return {ImageRecord}
   */
  contactImage() {
    return this._getOne("ContactImg", (i) => new ImageRecord(i));
  }
}



// WEBPACK FOOTER //
// ./src/models/HomePage.js